module.exports = __webpack_public_path__ + "img/SplashInnovation2.e535ac09.jpg";